import { Component, Input, inject, viewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CampaignLocationFilter, CampaignsCampaignReceiptLocationFilterAdminApiClient, PunchCardStrategy, ReceiptLocationCheckOptions, ReceiptLocationCheckType } from 'src/app/api/api-campaigns.service.generated';
import { CampaignLocationFiltersComponent } from '../campaign-location-filters/campaign-location-filters.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-receipt-locations-check-options-edit',
  templateUrl: './receipt-locations-check-options-edit.component.html',
  styleUrls: ['./receipt-locations-check-options-edit.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    FlexLayoutModule,
    CampaignLocationFiltersComponent
]
})
export class ReceiptLocationCheckOptionsEditComponent{
  private campaignReceiptLocationFiltersApi = inject(CampaignsCampaignReceiptLocationFilterAdminApiClient);

  @Input() campaignId: string;
  @Input() originalCampaignId: string;
  @Input() strategy: PunchCardStrategy;

  readonly locationFilters = viewChild<CampaignLocationFiltersComponent>('locationFilters');

  model: ReceiptLocationCheckOptions;
  locationCheckTypeTypes: { name: string, value?: ReceiptLocationCheckType }[] = [];
  locationFiltersEnabled: boolean;

  locForm = new FormGroup({
    locationFiltersEnabled: new FormControl(false),
    checkType: new FormControl(ReceiptLocationCheckType.Include)
  });

  constructor() {
    this.getLocationFilterTypes();
  }

  getLocationFilterTypes() {
    for (const key in ReceiptLocationCheckType)
      if (key)
        this.locationCheckTypeTypes.push({ name: key, value: ReceiptLocationCheckType[key] as ReceiptLocationCheckType });
  }


  public setFormValue(model: ReceiptLocationCheckOptions) {
    this.model = model || new ReceiptLocationCheckOptions({ checkType: ReceiptLocationCheckType.Include });

    this.locForm.patchValue({
      locationFiltersEnabled: !!model,
      checkType: this.model.checkType
    });
  }

  public getFormValue() {
    if (this.locForm.value.locationFiltersEnabled) {
      var receiptLocationCheckOptions = new ReceiptLocationCheckOptions();
      receiptLocationCheckOptions.init({
        ...this.locForm.value,
        locationFilter: this.locationFilters().getFormValue()
      });
      return receiptLocationCheckOptions;
    }
    else
      return undefined;
  }

  async ngOnInit() {
    if (!this.model)
      this.setFormValue(undefined);

    const campaignIdToUse = this.originalCampaignId || this.campaignId;
    const crlf = campaignIdToUse
      ? await lastValueFrom(this.campaignReceiptLocationFiltersApi.getByCampaignId2(campaignIdToUse))
      : new CampaignLocationFilter({ campaignId: this.campaignId, filters: [] });
    this.locationFilters()?.setFormValue(crlf);
  }
}
